import { useParams } from 'react-router-dom';
import { Fade } from '@mui/material';
import { useAuth_GetEmailVerificationQuery } from 'queries';

import Spinner from 'common/spinner';
import AuthLayout from 'layouts/auth-layout';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import Banner from './components/banner';
import VerifyEmailForm from './components/verify-email-form';

const VerifyEmailFormPage = () => {
  const { id, verificationCode } = useParams<Record<string, string>>();
  const { data: emailVerificationData, loading: emailVerificationLoading } =
    useAuth_GetEmailVerificationQuery({
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      skip: !id,
      variables: {
        id: id,
      },
      onError: (e) => {
        showAlert({
          message: 'Error getting email verification: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    });

  if (!id) {
    return <div>Invalid parameters</div>;
  }

  return (
    <AuthLayout>
      <Fade in={true}>
        <div>
          {!emailVerificationData && emailVerificationLoading && <Spinner />}
          {emailVerificationData && (
            <>
              <Banner
                verificationType={emailVerificationData.data.verificationType}
                showIcon={true}
              />
              <VerifyEmailForm
                emailVerification={emailVerificationData.data}
                verificationCode={verificationCode}
              />
            </>
          )}
        </div>
      </Fade>
    </AuthLayout>
  );
};

export default VerifyEmailFormPage;
